// MUI
import SpecialPages from "@Layouts/components/SpecialPages";
// Image
import AccessDeniedImage from "@/assets/images/notFound/403.png";

const AccessDenied = () => {
	const title = (
		<>
			Access <br /> Denied
		</>
	);
	const desc = "You do not have permission to access this page or resource. Click the button below to go back to the dashboard.";
	const image = AccessDeniedImage;
	const imageAlt = "Access Denied";
	const imgBoxClasses = "mt-[54px] mr-[225px]";
	return <SpecialPages title={title} description={desc} image={image} imageAlt={imageAlt} imgBoxClasses={imgBoxClasses} />;
};

export default AccessDenied;
